import { ofType } from "redux-observable";
import { of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import {
  actionTypes,
  fetchUgipConfigFailure,
  fetchUgipConfigSuccess,
  updateUgipConfigFailure,
  updateUgipConfigSuccess,
} from "./actions";
import { fetchUigpConfiguration, updateUigpConfiguration } from "./services";

const fetchUigpConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_UIGP_CONFIG_REQUEST),
    mergeMap((action: any) =>
      fetchUigpConfiguration().pipe(
        map((res: any) => fetchUgipConfigSuccess(res)),
        catchError((error: any) => of(fetchUgipConfigFailure(error)))
      )
    )
  );

const updateUigpConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST),
    mergeMap((action: any) =>
      updateUigpConfiguration(action.payload).pipe(
        map((res: any) => updateUgipConfigSuccess(res)),
        catchError((error: any) => of(updateUgipConfigFailure(error)))
      )
    )
  );

export default [fetchUigpConfigurationEpic, updateUigpConfigurationEpic];
